import {combineReducers} from "redux";
import utils from "./utils"
import user from "./user"


export default combineReducers({ utils, user});